module.exports = __webpack_public_path__ + "img/info.75625238.png";